module.exports = __webpack_public_path__ + "static/site-fact1-7b3c49910d76acc14aab82c51f971a97.jpg";